module.exports = __webpack_public_path__ + "img/SUUNTO-icon.6c229702.png";